(() => {
  if (customElements.get('countdown-timer')) {
    return;
  }

  /**
   * Countdown timer component.
   */
  class CountdownTimer extends HTMLElement {
    /**
     * Constructor.
     */
    constructor() {
      super();
      this.elements = {
        expireDate: this.querySelector('[data-expire-date]'),
        counter: {
          days: this.querySelector('[data-counter-days]'),
          hours: this.querySelector('[data-counter-hours]'),
          minutes: this.querySelector('[data-counter-minutes]'),
          seconds: this.querySelector('[data-counter-seconds]'),
        },
      };
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Initialize.
     *
     * @returns {Void}
     */
    init() {
      if (
        !this.elements.expireDate ||
        this.classList.contains('is-initialized')
      )
        return;
      const endDate = Number(this.elements.expireDate.getAttribute('datetime'));
      let nowDate = Number(this.dataset.currentTime);
      const interval = setInterval(() => {
        const diff = endDate - nowDate;

        if (diff <= 0) {
          clearInterval(interval);
          this.setCounter();
          this.setExpired();
          return;
        }

        const minutesTimestamp = 1000 * 60;
        const hoursTimestamp = minutesTimestamp * 60;
        const daysTimestamp = hoursTimestamp * 24;

        const days = Math.floor(diff / daysTimestamp);
        const hours = Math.floor((diff % daysTimestamp) / hoursTimestamp);
        const minutes = Math.floor((diff % hoursTimestamp) / minutesTimestamp);
        const seconds = Math.floor((diff % minutesTimestamp) / 1000);
        this.setCounter({ days, hours, minutes, seconds });
        nowDate = nowDate + 1000;
      }, 1000);

      this.classList.add('is-initialized');
    }

    /**
     * Set counter.
     *
     * @param {Object} dateObject
     */
    setCounter(dateObject = {}) {
      ['days', 'hours', 'minutes', 'seconds'].map((dateItemKey) => {
        const dateItem = dateObject[dateItemKey] ? dateObject[dateItemKey] : 0;
        if (!this.elements.counter[dateItemKey]) {
          return;
        }
        if (dateItemKey !== 'seconds' && dateItem === 0) {
          this.elements.counter[dateItemKey].parentElement.remove();
          return;
        }
        this.elements.counter[dateItemKey].innerHTML =
          dateItemKey === 'seconds'
            ? dateItem
            : `${dateItem}`;

        this.elements.counter[dateItemKey].nextElementSibling.innerHTML =
          dateItem === 1
            ? window.dateStrings[`${dateItemKey}Single`]
            : window.dateStrings[`${dateItemKey}`];
      });
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
